import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623dbf19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "STUDENT BENEFITS", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive } from 'vue'
    import PageHeader from '@/components/wap/PageHeader-wap.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WapStudentView',
  setup(__props) {

    const paragraph = [
      {
        title:'GEP assists students who would like to study outside their countries',
        data:'GEP offers the following services<br><br>&nbsp&nbsp&nbsp1.&nbsp&nbsp&nbspAssess your qualifications and eligibility based on the country that you have chosen.<br>&nbsp&nbsp&nbsp2.&nbsp&nbsp&nbspPrepare you for the college or university requirements including English<br>&nbsp&nbsp&nbsp3.&nbsp&nbsp&nbspOrganise college or university that has you chosen qualification.<br>&nbsp&nbsp&nbsp4.&nbsp&nbsp&nbspPlan a pathway should you choose to stay in the country after your studies (only applies to International Students who choose Australia)<br>&nbsp&nbsp&nbsp5.&nbsp&nbsp&nbspPrepare itemised quote of all requirements<br><br>GEP works with MARA Registered Agent for your Visa Applications</p>'
      }
    ];

    const data = reactive(
      {
        paragraph:paragraph,
        rootPath:'/education-wap',
        root:'Education',
        current:'student benefit',
        currentPath:'/student-wap',
        inquiryPath:'/contact-wap',
        isPara:true,
        isTable:false
      }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})